import Pagination from '../../../container/pagination/Pagination';

import {
  type ChangeNumberAtomPromise,
  lastPageLoadedIncludingLoadMoreAtom,
} from '@vs-shop/engine/atom/products/pagination';
import type { HydraViewExtended } from '@vs-shop/schemas/openapi/hydraView';

type Props = {
  hydraViewExtended: HydraViewExtended;
  changePage: ChangeNumberAtomPromise;
  scrollToGrid: () => void;
  baseUrl: string;
  searchParams?: Record<string, string> | undefined;
};

export default function ArticlesPagination({
  hydraViewExtended,
  changePage,
  scrollToGrid,
  baseUrl,
  searchParams,
}: Props) {
  return (
    <Pagination
      hydraViewExtended={hydraViewExtended}
      changePage={changePage}
      scrollToGrid={scrollToGrid}
      baseUrl={baseUrl}
      lastPageLoadedIncludingLoadMoreAtom={lastPageLoadedIncludingLoadMoreAtom}
      searchParams={searchParams}
    />
  );
}
